import { loader } from 'graphql.macro'

export default function quickbooksFeeTypesQuery ({ dataLoaders, queryKey }) {
  const [, haulerId] = queryKey
  const qboFeeTypesSchema = loader('./quickbooksFeeTypes.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(qboFeeTypesSchema, { haulerId })
}
